module.exports = __webpack_public_path__ + "images/assets/f10ea2eefcca2011b1587939b570b38b.svg";